(function ($) {
  /**
   * Return the offset amount to deduct from the normal scroll position.
   * Modify as appropriate to allow for dynamic calculations.
   * @param {HTMLDocument} context - The html document.
   */
  function getFixedOffset(context) {
    let height = 0;
    const toolbar = context.getElementById("toolbar-bar");
    const toolbarTray = context.getElementById(
      "toolbar-item-administration-tray"
    );

    if (toolbar) {
      height += $(toolbar).height();
    }
    if (toolbarTray && $(toolbarTray).hasClass("is-active")) {
      height += $(toolbarTray).height();
    }

    const tableHeader = context.querySelectorAll(".usa-table--sticky-header thead");
    if (tableHeader.length !== 0) {
      height += $(tableHeader[0]).height();
    }
    return height;
  }

  /**
   * If the provided href is an anchor which resolves to an element on the
   * page, scroll to it.
   * @param {HTMLDocument} context - The html document.
   * @param {String} href - Anchor href.
   * @param {Boolean} pushToHistory - Register anchor navigations to history.
   * @return {Boolean} - Was the href an anchor.
   */
  function scrollIfAnchor(context, href, pushToHistory) {
    if (!/^#[^ ]+$/.test(href)) {
      return false;
    }

    const match = context.getElementById(href.slice(1));

    if (match) {
      // Targets table cell.
      const anchorOffset =
        $(match).parent().offset().top - getFixedOffset(context);
      $("html, body").animate({ scrollTop: anchorOffset });

      // Add the state to history as-per normal anchor links
      if (!!(window.history && window.history.pushState) && pushToHistory) {
        window.history.pushState(
          {},
          context.title,
          window.location.pathname + href
        );
      }
    }

    return !!match;
  }

  /**
   * Attempt to scroll to the current location's hash.
   * @param {HTMLDocument} context - The html document.
   * @param {(Event|null)} e - The event.
   */
  function scrollToCurrent(context, e) {
    if (scrollIfAnchor(context, window.location.hash, true) && e) {
      e.preventDefault();
    }
  }

  /**
   * If the click event's target was an anchor, fix the scroll position.
   * @param {HTMLDocument} context - The html document.
   * @param {(Event|null)} e - The event.
   */
  function delegateAnchors(context, e) {
    const elem = e.target;

    if (scrollIfAnchor(context, elem.getAttribute("href"), true)) {
      e.preventDefault();
    }
  }

  /**
   * Establish events, and fix initial scroll position if a hash is provided.
   * @param {HTMLDocument} context - The html document.
   */
  function init(context) {
    scrollToCurrent(context, null);
    $(window).on("hashchange", (e) => scrollToCurrent(context, e));
    $(context).on("click", "a", (e) => delegateAnchors(context, e));
  }

  Drupal.behaviors.stickyHeaderCorrection = {
    attach(context) {
      once("stickyHeaderCorrection", "body", context).forEach(() =>
        init(context)
      );
    },
  };
})(jQuery);
